<template lang="pug">
.row
    .col-md-12
        .box
            v-server-table(
                :url="api",
                :name="tableName",
                ref="datatable",
                :columns="columns",
                :options="options"
            )
                template(slot="quantity", slot-scope="props")
                    span._500 {{ props.row.quantity }}
</template>

<script>
const exportRoute = 'stocks.inventories.export';

export default {
    data() {
        var that = this;

        return {
            tableName: 'VUETABLE_STOCK',
            level: null,
            columns: [
                'name',
                'sku',
                'barcode',
                'quantity',
                'low_stock_level',
                'ideal_stock_level',
                'outlet',
            ],
            options: {
                useReportFilter: true,
                customFilters: ['level'],
                texts: {
                    title: 'Supply Needs',
                    description:
                        'List of stock below or equal to low stock level',
                },
                pdf_url: Laroute.route(exportRoute, { type: 'PDF' }),
                csv_url: Laroute.route(exportRoute, { type: 'CSV' }),
                xls_url: Laroute.route(exportRoute, { type: 'XLSX' }),
                columnsClasses: {
                    quantity: 'quantity text-center',
                    low_stock_level: 'text-center',
                    ideal_stock_level: 'text-center',
                },
                skin: 'table m-b-0 b-b',
                initFilters: {
                    level: 'low',
                },
                perPage: 10,
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stocks.inventories.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/supply-needs.vue